import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeRegistrationService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  InsertUpdate(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `Employee/InsertUpdate`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetCompulsoryFields(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Compulsory/Fields`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  // GetData(EmployeeDetail: any) {
  //   return this.http.post<any>(environment.API_URL + `EmpRegSelect/GetData`,
  //     this.session.SetClass(EmployeeDetail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }

  GetData(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `EmpRegistrationAll/GetData`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  EmpRegSelectGetData(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `EmpRegSelect/GetData`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpRegistration_SearchGet(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpRegistration_Search/Get`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetAadharPanBankCompulsory(Detail: any) {
    return this.http.post<any>(environment.API_URL + `AadharPanBank/Status`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  PanAadharBankDuplicate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Validation/PanAadharBank`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SaveVerification(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `SaveVerification/Data`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  TabWise(EmployeeDetail: any) {
    return this.http.post<any>(environment.API_URL + `EmployeeRegistration/TabWise`,
      this.session.SetClass(EmployeeDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  EmployeeFinalSubmit(Detail: any) {
    return this.http.post<any>(environment.API_URL + `EmployeeFinal/Submit`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SaveEmpPreOnBoarding(PreonboardinSetupDetail: any) {
    return this.http.post<any>(environment.API_URL + `EmpPreOnBoarding/InsertUpdate`,
      this.session.SetClass(PreonboardinSetupDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SendPreOnBoardingLink(PreonboardinDetail: any) {
    return this.http.post<any>(environment.API_URL + `LinkCreation/LoginLink`,
      this.session.SetClass(PreonboardinDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESSEmpOnlineRegistrationRejectSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Proc_ESS_EmpOnlineRegistration_Reject/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESSEmpOnlineRegistrationUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpOnlineRegistration/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  CompanyEmployeeDetailsSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_CompanyDetailsSelect/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  CompanyEmployeeDetailsInserUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_CompanyDetails/InsertUpdate`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_PreOnBoardingSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_PreOnBoarding/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_SendReminderMailSend(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SendReminderMail/Send`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_GetEmployeeDumpReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_GetEmployeeDump/Report`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpMobileEmailDuplicateCheck(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpMobileEmailDuplicate/Check`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpDraftClear(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpDraftClear/Record`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  //sub contractor
  ESS_EmpSubContractor_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpSubContractor_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  //sub contractor
  ESS_EmployeeSubcontracterSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeSubcontracter/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  EmployeeFinal_BgvSubmit(Detail: any) {
    return this.http.post<any>(environment.API_URL + `EmployeeFinal_Bgv/Submit`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_AdditionalFillCombo(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_Additional/FillCombo`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeRejoinProcess(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeRejoin/Process`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpZingHrSyncSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpZingHrSync/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmpZingHrSyncInESS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmpZingHrSyncIn/ESS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
